import * as React from 'react';
import SafeAreaPage from 'layouts/SafeAreaPage';
import Head from 'components/utilities/Head';
import MarkdownStyler from 'components/utilities/MarkdownStyler';

const PrivacyPolicy = () => {
  return (
    <>
      <Head title="Privacy Policy" description="Bounce privacy policy" />
      <SafeAreaPage isHideSidebar>
        <MarkdownStyler className="mx-auto max-w-main-content-container p-6">
          <h1>
            <strong>PRIVACY POLICY</strong>
          </h1>
          <p>
            <strong>1. In General.</strong>
          </p>
          <p>
            This Privacy Policy (this “Policy”) describes how Advantage Platform Inc. (“Advantage”
            or “we”) DBA Bounce Platform Inc ("Bounce") treats the personal information of its
            customers using, and others visiting, our websites. Your use of this website constitutes
            your agreement to our collection, use and disclosure of your information as described in
            this Policy.
          </p>
          <p>
            California users of this website should refer to Section 13 below (“Privacy Rights and
            Other Rights of Person Residing in California”) for additional information related to
            their rights under California law.
          </p>
          <p>
            <strong>2. We collect information from and about you.</strong>
          </p>
          <p>
            <strong>We collect contact information.</strong> For example, we collect your name and
            mailing address if you register with us. We also collect email addresses and phone
            numbers to process your purchases and other transactions on our websites and to stay in
            contact with you regarding the status of such purchases and other transactions.
          </p>
          <p>
            <strong>Third parties collect payment information via our websites.</strong> If you
            purchase services on any of our websites, the data necessary to process your payment,
            such as your debit or credit card number and related debit or credit card information,
            will be collected, via our website, by a third party that processes payments for us (but
            your debit or credit card number and related debit or credit card information will not
            be collected by us).
          </p>
          <p>
            <strong>We collect information you submit online.</strong> This includes information you
            post when you interact with us on social media platforms.
          </p>
          <p>
            <strong>
              We collect demographic information and information about service preferences.
            </strong>{' '}
            This includes collecting your age and gender.
          </p>
          <p>
            <strong>We collect information about your device and location.</strong> We collect the
            type of device you use to access our websites. We also collect information about the
            type of browser you are using and we may look at what site you came from or what site
            you go to when you leave us. We may look at how often you use our websites.
          </p>
          <p>
            <strong>We collect information about your use of our websites.</strong> This includes
            browsing activity, how you interact with our websites, the services that you buy, and
            search terms that you enter.
          </p>
          <p>
            <strong>3. We collect information about you in different ways.</strong>
          </p>
          <p>
            <strong>We collect information about you directly from you.</strong> This includes when
            you create an account or purchase services. We also collect information if you contact
            customer service or sign up to receive information from us. We also collect information
            when you take a survey or participate in a promotion.
          </p>
          <p>
            <strong>We collect information about you passively.</strong> We use tracking tools like
            browser cookies and web beacons. We use these tools on our websites and in emails we
            send to you. We collect information about you over time when you use our websites. We
            also have arrangements with third parties who act on our behalf to collect information
            on our websites this way.
          </p>
          <p>
            <strong>We get information about you from third parties</strong>. Such third parties
            include, but are not limited to, social media platforms.
          </p>
          <p>
            <strong>
              4. We combine information about you that we collect from different sources.
            </strong>
          </p>
          <p>
            We combine offline and online information and we combine information across multiple
            devices. We also combine information we get from third parties with information we
            already have about you.
          </p>
          <p>
            <strong>5. We use information about you in the following ways.</strong>
          </p>
          <p>
            <strong>We use your information to provide you with services.</strong> This includes
            providing you with the services offered on our website. It also includes sending you
            communications that you signed up to receive.
          </p>
          <p>
            <strong>We use your information to improve our services and websites.</strong> We may
            use your information to improve our services and websites. We may also use your
            information (including information about your interests and preferences) to customize
            your experience with us.
          </p>
          <p>
            <strong>We use your information to respond to your requests</strong>. This includes
            responding to customer inquiries.
          </p>
          <p>
            <strong>We use your information to communicate with you.</strong> We may communicate
            with you about your account or our relationship. These communications include electronic
            messages (such as SMS or push notifications) and calls about order status. We may also
            contact you about this Policy or our website’s Terms and Conditions.
          </p>
          <p>
            <strong>We use your information for marketing purposes.</strong> We may provide you with
            information about new services and special offers. We may also serve you ads,
            personalized or not, about services and offers that we think you might find interesting.
            These services and offers may be third-party services or offers. In addition, we may
            tell you about new website features or updates.
          </p>
          <p>
            <strong>We use your information for security and fraud prevention purposes.</strong> We
            may use your information to protect our customers and Bounce (including our may use your
            information to protect our customers and Bounce (including our websites).
          </p>
          <p>
            <strong>We may use your information to meet our legal obligations.</strong> In certain
            cases, we collect and use your information to comply with laws.
          </p>
          <p>
            <strong>
              We may use your information as otherwise permitted by law, subject to notification to
              you if required by law.
            </strong>
          </p>
          <p>
            <strong>6. We share your information with third parties.</strong>
          </p>
          <p>
            <strong>
              We may share your information with third parties who perform services for us
            </strong>
            . We share information with payment processors. We also share information with
            advertising and marketing service providers that, for example, send emails on our
            behalf.
          </p>
          <p>
            <strong>We share your information with our business partners.</strong> For example, we
            share information with third-party advertisers, including third-party cookie providers
            who collect information through our websites for marketing, analytics or
            functionality-improvement purposes.
          </p>
          <p>
            <strong>
              We may give access to your information to third-parties acting on our behalf.
            </strong>{' '}
            We may contract with third-party service providers to assist us in better understanding
            our site visitors by collecting information from our websites. Such third parties may
            use “cookies “ to collect such information. (See Section 7 regarding “cookies.”)
            However, these service providers are not permitted to use the information collected on
            our behalf other than to help us conduct and improve our websites.
          </p>
          <p>
            <strong>
              We may share your information with any successor to all our part of our business.
            </strong>{' '}
            If Bounce is sold in whole or in part, we may transfer customer information as part If
            Bounce is sold in whole or in part, we may transfer customer information as part of that
            transaction.
          </p>
          <p>
            <strong>
              We will share your information if we think we are required to do so in order to comply
              with law or to protect ourselves.
            </strong>{' '}
            This could include responding to a court order or subpoena. It could also include
            sharing your information with a government agency or investigatory body that requests
            it. We might share information when we are investigating a potential fraud (for example,
            but not only, fraud we think has occurred during a sweepstakes or promotion). If you are
            the winner of a sweepstakes or other contest, we may also share information with anyone
            who requests a list of winners.
          </p>
          <p>
            <strong>
              We may share your information as otherwise permitted by law, subject to notification
              to you if required by law.
            </strong>
          </p>
          <p>
            <strong>7. We use “cookies.”</strong> Cookies are small files that a website or its
            service provider transfers to your computer&#39;s hard drive through your Web browser
            (if you permit that to happen). Cookies allow the site&#39;s or service provider&#39;s
            systems to recognize your browser and capture and remember certain information. For
            instance, we use cookies to help us remember and process the items in your shopping
            cart. They are also used to help us understand your preferences based on previous or
            current site activity, which enables us to provide you with improved services. We also
            use cookies to help us compile aggregate data about site traffic and site interaction so
            that we can offer better site experiences and tools in the future. As noted above in
            Section 6, third-party service providers acting on our behalf may also use cookies on
            our websites.
          </p>
          <p>
            <strong>8. You have certain choices about how we use your information.</strong>
          </p>
          <p>
            <strong>You can opt out of receiving our marketing emails.</strong> To stop receiving
            our promotional emails and messages follow the instructions in any promotional email or
            message that you get from us. Even if you opt out of getting marketing emails and/or
            messages, we will still contact you regarding your purchases and in response to your
            questions.
          </p>
          <p>
            <strong>You can control cookies and tracking tools.</strong> Your browser may give you
            the ability to control cookies or other tracking tools. How you do so depends on the
            type of browser you are using. Certain browsers can be set to reject browser cookies.
            Flash cookies, which we may use on our websites from time to time, cannot be controlled
            through your browser settings. To control flash cookies, you can go to{' '}
            <a href="http://www.aboutads.info/choices/.Why?">
              http://www.aboutads.info/choices/.Why?
            </a>{' '}
            If you block or reject cookies, certain features on our sites may not work. In addition,
            if you block or reject cookies, not all of our tracking will stop.
          </p>
          <p>
            <strong>Our Do Not Track Policy.</strong> Some browsers have “do not track” features
            that allow you to tell a website not to track you. These features are not all uniform
            and we do not currently respond to “do not track” settings or signal, so even if you
            activate those settings or signals, our tracking will continue.
          </p>
          <p>
            <strong>
              When you are using a mobile device, you can limit tracking by deactivating various
              tools.
            </strong>{' '}
            For example, you can turn off Bluetooth, GPS locator, push notifications or your
            advertising ID in your mobile device settings.
          </p>
          <p>
            <strong>
              Any options that you select to limit cookies or tracking are browser and
              device-specific.
            </strong>{' '}
            If you wish to block or reject cookies or otherwise limit tracking, you will need to do
            so separately on each device and browser that you use.
          </p>
          <p>
            <strong>9. Our websites are not intended for children.</strong> We do not offer services
            to children. Our websites are meant for adults, meaning persons 18 years of age or
            older. If you are under 18 years old, you may not use our websites. Because are websites
            are not intended to be used by children, we do not knowingly collect personally
            identifiable data from children. If you are a parent or legal guardian and think your
            child has given us information, you can write to us at:
          </p>
          <p>Advantage Platform Inc.</p>
          <p>Bounce Platform Inc.</p>
          <p>Attn: COPPA Information Request</p>
          <p>142 West 57th Street</p>
          <p>New York, NY 10019</p>
          <p>
            Alternatively, you may email us at{' '}
            <a href="mailto:team@bounce.game">team@bounce.game</a> with your question. If you email
            us, please put “COPPA Information Request” in the subject line of your email.
          </p>
          <p>
            Parents and guardians, you can learn more about how to protect children&#39;s privacy
            on-line visiting:{' '}
            <a href="https://www.consumer.ftc.gov/articles/0031-protecting-your-childs-privacy-online">
              https://www.consumer.ftc.gov/articles/0031-protecting-your-childs-privacy-online
            </a>
            .
          </p>
          <p>
            <strong>
              10. We use standard security measures, but the Internet is not completely secure.
            </strong>{' '}
            The Internet is not 100% secure. We cannot promise that your use of our websites will be
            completely safe. We encourage you to use caution when using the Internet, including our
            websites.
          </p>
          <p>
            <strong>
              11. We may link to other websites, or have third party tools on our websites, that we
              don
            </strong>
            ’<strong>t control.</strong> Our websites may have links that will take you to
            third-party websites that we do not control. In addition, third parties may have ads or
            content on our websites that will also lead you to third-party websites. We are not
            responsible for the privacy practices of any third parties, which may be different than
            ours. We suggest that you read their privacy policies carefully.
          </p>
          <p>
            <strong>12. You can contact us if you have questions.</strong> If you have additional
            questions about our privacy practices, you can write to us at:
          </p>
          <p>Advantage Platform Inc.</p>
          <p>Bounce Platform Inc.</p>
          <p>Attn: Privacy</p>
          <p>142 West 57th Street</p>
          <p>New York, NY 10019</p>
          <p>
            Alternatively, you may email us at{' '}
            <a href="mailto:team@bounce.game">team@bounce.game</a> with your question. If you email
            us, please put “Privacy” in the subject line of your email.
          </p>
          <p>
            <strong>13. Privacy Rights and Other Rights of Persons Residing in California.</strong>{' '}
            We collect various types of personal information about you both online and offline, as
            described above in this Privacy Policy. If you reside in California, we are required by
            California law to provide you with additional information about how we collect, use and
            disclose your personal information, about additional rights that you may have with
            regard to how we collect, use and disclose your personal information and about your
            rights to learn about and control our disclosure of your personal information. This
            California-specific information is as follows:
          </p>
          <p>
            <strong>California “Shine the Light” Law.</strong> Under the California “Shine the
            Light” law, our customers who are residents of California may request certain
            information about our disclosure of their personal information during the prior calendar
            year to third parties for direct marketing purposes. To make such a request, please
            write to us at the following address:
          </p>
          <p>Advantage Platform Inc.</p>
          <p>Bounce Platform Inc.</p>
          <p>Attn: California Shine the Light</p>
          <p>142 West 57th Street</p>
          <p>New York, NY 10019</p>
          <p>
            Alternatively, you may make your request by email to us at{' '}
            <a href="mailto:team@bounce.game">team@bounce.game</a> with the words &quot;California
            Shine the Light&quot; in the subject line.
          </p>
          <p>
            <strong>California Consumer Privacy Act Disclosure.</strong> Following is a California
            Consumer Privacy Act disclosure, which supplements the other information in this Policy.
            This disclosure is effective as of November 22, 2022 (the “Effective Date”).
          </p>
          <p>
            <strong>
              <em>Collection of Personal Information.</em>
            </strong>{' '}
            Consistent with Section 2 above in this Policy, during the 12 months preceding the
            Effective Date we collected personal information as follows (regardless of the means
            (online or in person) that California residents have used to interact with us):
          </p>
          <ul>
            <li>
              We collected the types of personal information that fall into the following categories
              of information established by the California Consumer Privacy Act: identifiers,
              commercial information, protected characteristics, Internet or other electronic
              network activity information, geolocation data, audio and/or visual data, electronic
              information and inference data.
            </li>
            <li>
              We collected that personal information directly via our websites, and from third
              parties, as described in Sections 3 and 4 of this Policy.
            </li>
          </ul>
          <p>
            <strong>
              <em>Use of Personal Information.</em>
            </strong>{' '}
            During the 12 months preceding the Effective Date, we used personal information that
            falls into the categories of information referred to in the “Collection of Personal
            Information” section immediately above in the manner described in Section 5 above in
            this Policy.
          </p>
          <p>
            <strong>
              <em>Sharing and Disclosure of Personal Information.</em>
            </strong>
          </p>
          <ul>
            <li>
              During the 12 months preceding the Effective Date, we shared personal information that
              falls into the categories of information referred to in the “Collection of Personal
              Information” section above in the manner described in Section 6 above in this Policy,
              including disclosures made to third parties for business purposes and “sales” of
              information (as that term is defined under the California Consumer Privacy Act, which
              may include disclosures where no money or other consideration is exchanged) for the
              purposes described in Section 6 above in this Policy. During the 12 months preceding
              the Effective Date, we disclosed the following categories of personal information for
              a business purpose to the following categories of recipients:
            </li>
          </ul>
          <p>Identifiers, which were disclosed to our service providers.</p>
          <p>
            Name and last name; email; address; telephone number; signature; image/voice; electronic
            signature; information regarding transactions of goods and services; advertising ID;
            purchase amount; and frequency of purchases, all of which was disclosed to our service
            providers.
          </p>
          <p>
            <strong>
              <em>Other Sales of Personal Information.</em>
            </strong>{' '}
            When you navigate through our website, we “sell” (as that term is defined under the
            California Consumer Privacy Act, which may include disclosures where no money or other
            consideration is exchanged) your personal information to our business partners. That
            information includes identifiers (including Advertising ID and hashed email),
            information about services you have obtained from us, purchase amounts and browsing
            events.
          </p>
          <p>
            <strong>California Residents’</strong> <strong>Privacy Rights.</strong>
          </p>
          <p>
            Subject to certain exceptions, California residents have the right to: (i) request
            access to their personal information; (ii) request deletion of their personal
            information; and (iii) request information about the personal information that we have
            collected, used, sold, or disclosed to third parties within the past 12 months. You may
            exercise these rights by making a request as provided at the end of this paragraph. When
            you submit a request, we may require additional information from you to verify your
            identity. You may also use an authorized agent to submit requests on your behalf. If you
            do use an authorized agent, then along with the request, the authorized agent must
            submit a copy of your signed permission to submit the specific request. To make a
            request, you can write to us at the following address:
          </p>
          <p>Advantage Platform Inc.</p>
          <p>Bounce Platform Inc.</p>
          <p>Attn: California Privacy Rights</p>
          <p>142 West 57th Street</p>
          <p>New York, NY 10019</p>
          <p>
            Alternatively, you may make your request by email to us at{' '}
            <a href="mailto:team@bounce.game">team@bounce.game</a> with the words &quot;California
            Privacy Rights&quot; in the subject line.
          </p>
          <p>
            <strong>California Residents’ “Do Not Sell My Personal Information” Rights.</strong> In
            addition to the rights described above, you have the right to opt out of the sale of
            your personal information to third parties. You can exercise this right either by (1)
            clicking the “<em>Do Not Sell My Personal Information</em>” link displayed on the
            website homepage and following the instructions on that page; (2) by writing to us at
            the following address: Advantage Platform Inc., Attn: Do Not Sell My Personal
            Information, 142 West 57th Street, New York NY 10019; or (3) by emailing us at{' '}
            <a href="mailto:team@bounce.game">team@bounce.game</a> with the words &quot;Do Not Sell
            My Personal Information&quot; in the subject line.{' '}
          </p>
          <p>
            <strong>
              <em>Sales of Information of Persons under 16 years of Age.</em>
            </strong>{' '}
            As we do not offer services to persons under 18 years of age, to our knowledge we do not
            obtain any personal information of consumers under 16 years of age.
          </p>
          <p>
            <strong>
              <em>Non-Discrimination.</em>
            </strong>{' '}
            We will not discriminate against you because you exercised your rights under the
            California Consumer Privacy Act.
          </p>
          <p>
            <strong>14. We may change this Policy.</strong>
          </p>
          <p>
            From time to time, we may change this Policy. We will notify you of any material changes
            to this Policy as required by law. We will also post an updated copy of this Policy on
            our websites. Please check our websites periodically for updates.
          </p>
          <p>
            <strong>Date: November 22, 2022</strong>
          </p>
        </MarkdownStyler>
      </SafeAreaPage>
    </>
  );
};

export default PrivacyPolicy;
